import React from 'react';
import firebase from 'firebase';
import { Redirect, Route } from 'react-router-dom';

class Authenticated extends React.Component {
  state = {
    loggingIn: true,
    isSignedIn: false,
  }

  componentDidMount() {
    firebase.auth().onAuthStateChanged(user => {
      if (user && user.displayName === 'admin') {
        this.setState({ loggingIn: false, isSignedIn: true });
      } else {
        this.setState({ loggingIn: false, isSignedIn: false });
      }
    });
  }

  render() {
    const { exact, path, component } = this.props;
    const { loggingIn, isSignedIn } = this.state;

    return (
      <Route
        exact={exact}
        path={path}
        render={props => {
          if (loggingIn) return <React.Fragment />;
          if (!isSignedIn) return <Redirect to="/login" />;

          return React.createElement(component, { ...props });
        }}
      />
    );
  }
}

export default Authenticated;
